import comp0 from '@/app/overlaybackground'
import comp1 from '@/app/productoverview'
import comp2 from '@/app/quizapp'
var map={}; 
map['app/overlaybackground']=comp0;
map['app/productoverview']=comp1;
map['app/quizapp']=comp2;
export default map;